import { render, staticRenderFns } from "./WorkflowEmailSendDetailDialog.vue?vue&type=template&id=5e61d6b8"
import script from "./WorkflowEmailSendDetailDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowEmailSendDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports